import { useNavigate } from 'react-router-dom';

import { BsRocketTakeoff } from 'react-icons/bs';

import AppBanner from '#globalComponents/AppBanner/AppBanner';
import { useAuth } from '#globalContexts/AuthProvider';
import { CRM_ADDON } from '#lib/addons/addonConfigs';
import { useAddonTrial } from '#lib/addons/useAddonTrial';
import { BILLING_SETTINGS_PATH } from '#lib/constants/routes';
import { usePreferencesStore } from '#lib/stores/preferencesStore';

const DemoUpgradeBanner = () => {
	const { orgPlan } = useAuth();
	const { isOnTrial } = useAddonTrial(CRM_ADDON.key);
	const dismissed = usePreferencesStore((s) => s.demoUpgradeBannerDismissed);
	const setDismissed = usePreferencesStore((s) => s.setDemoUpgradeBannerDismissed);
	const navigate = useNavigate();

	const isCancelled = orgPlan === 'cancelled';

	// A demo user on the CRM trial should see the trial countdown, not the generic demo banner.
	if (isOnTrial) return null;
	if ((orgPlan !== 'demo' && !isCancelled) || dismissed) return null;

	return (
		<AppBanner
			tone="accent"
			icon={BsRocketTakeoff}
			action={{
				label: isCancelled ? 'Jetzt reaktivieren' : 'Jetzt upgraden',
				onClick: () => navigate(BILLING_SETTINGS_PATH),
			}}
			onDismiss={() => setDismissed(true)}
		>
			{isCancelled ? (
				<>
					Ihr Abonnement ist <strong>beendet</strong>. Reaktivieren Sie es, um wieder alle Features
					freizuschalten.
				</>
			) : (
				<>
					Sie nutzen die <strong>Demo-Version</strong>. Upgraden Sie jetzt und schalten Sie alle Features
					frei.
				</>
			)}
		</AppBanner>
	);
};

export default DemoUpgradeBanner;
